import { makeStyles, createStyles } from '@material-ui/core'

export const useTabsJob = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 25
    },

    title: {
      marginBottom: 24,
      fontFamily: 'Montserrat',
      fontSize: 36,
      fontWeight: 600,
      color: '#333333',
      [theme.breakpoints.down(960)]: {
        fontSize: 22,
        marginBottom: 0
      }
    },

    tab: {
      '&.MuiTab-root': {
        padding: 0,
        margin: '0 22px',
        fontFamily: 'Montserrat',
        fontSize: 16,
        fontWeight: 600,
        [theme.breakpoints.up(300)]: {
          minWidth: 'fit-content'
        },
        [theme.breakpoints.down(960)]: {
          fontSize: 12,
          margin: '0 10px'
        }
      }
    },

    divider: {
      width: '98vw'
    }
  })
)
